const permissions = {
  listVehicle: 'UP013',
  addVehicle: 'UP014',
  editVehicle: 'UP015',
  removeVehicle: 'UP016'
};

export default permissions;
